<template>
  <div class="meetdetail">
    <Header style="width:100%" :title="$t('m.MeetingDetails')"></Header>
    <div class="row">
      <div class="row_label">{{$t('m.MeetingName')}}</div>
      <div>{{meeting.meeting_name}}</div>
    </div>

      <template v-if="sameLinks">
        <div :key="index" class="row" v-for="(item,index) in meeting.callInfoMap.internalCallUrlList">
          <span v-if="index==0" style="visibility: visible">{{$t('m.JoiningMeetingURL')}}</span>
          <span v-else style="visibility: hidden">{{$t('m.JoiningMeetingURL')}}</span>
          <span class="color" style="margin-left:0.2rem;">
            <a :href="item" @click="toshow">{{item}}</a>
          </span>
        </div>
      </template>
      <template v-else>
        <div :key="index" class="row" v-for="(item,index) in meeting.callInfoMap.internalCallUrlList">
          <span v-if="index==0" style="visibility: visible">{{$t('m.IntranetJoinURL')}}</span>
          <span v-else style="visibility: hidden">{{$t('m.IntranetJoinURL')}}</span>
          <span class="color" style="margin-left:0.2rem;">
            <a :href="item" @click="toshow">{{item}}</a>
          </span>
        </div>
        <template v-if="meeting.callInfoMap && meeting.callInfoMap.externalCallUrlList.length>0">
        <div :key="index" class="row" v-for="(item,index) in meeting.callInfoMap.externalCallUrlList">
          <span v-if="index==0" style="visibility: visible">{{$t('m.ExternalNetworkURL')}}</span>
          <span v-else style="visibility: hidden">{{$t('m.ExternalNetworkURL')}}</span>
          <span class="color" style="margin-left:0.2rem;">
            <a :href="item" @click="toshow">{{item}}</a>
          </span>
        </div>
        </template>
        <template v-else-if="meeting.callInfoMap.externalCallUrlList.length==0 && meeting.callInfoMap.internalCallUrlList.length>0">
        <div class="row">
          <span>{{$t('m.ExternalNetworkURL')}}</span>
          <span style="margin-left:0.2rem;">
            {{$t('m.NotAbilityCallOutsideNetworkPleaseContactPolyTechnicalTeamForSupport')}}
          </span>
        </div>
        </template>
      </template>

      <div class="row" v-if="meeting.vcesCallUrl">
        {{$t('m.TiangongJoiningConnection')}}
		<span style="margin-left:0.2rem;" v-html="meeting.vcesCallUrl"></span>
      </div>
	
    <div class="warp">
      <div class="qrcodewarp">
        <!--放二维码图片-->
        <div id="qrcode" :title="meeting.qrcode">
          <img alt="Scan me!" style="display: block;" :src="meeting.qrcode" />
        </div>
      </div>
      <!-- <canvas id="qrcode"></canvas> -->
      <div style="line-height:0.2rem;">{{$t('m.ScanQRCodeJionMeeting')}}</div>
    </div>
    <div class="row" v-if="meeting.system_tel">
      <div class="row_label">{{$t('m.TelephoneAccess')}}</div>
      <div>{{meeting.system_tel}}</div>
    </div>
    <div class="row" v-if="meeting.liveurl">
      <div class="row_label">{{$t('m.LiveURL')}}</div>

      <span>
        <a :href="meeting.liveurl" target="_blank">{{$t('m.ClickToWatchLive')}}</a>
      </span>
    </div>
	
	  <div class="row" v-if="!meeting.vcesCallNumber || meeting.vcesCallNumber !=meeting.vmr_id">
        <div class="row_label">{{$t('m.MeetingNumber')}}</div>
        {{meeting.vmr_id}}
      </div>
	  
	  <div class="row" v-if="meeting.vcesCallNumber">
        <div class="row_label">{{$t('m.TiangongMeetingNumber')}}</div>
        {{meeting.vcesCallNumber}}
      </div>
	  
    <div class="row">
      <div class="row_label">{{$t('m.Password')}}</div>
      <div>{{meeting.meeting_password}}</div>
    </div>
    <div class="row">
      <div class="row_label">{{$t('m.StartTimeColon')}}</div>
      <div>
        {{meeting.meeting_date}}
        <!-- {{meeting.meeting_date|getdata}} -->
      </div>
    </div>
    <div class="row">
      <div class="row_label">{{$t('m.MeetingDuration')}}</div>
      <div>{{meeting.meeting_long}} {{$t('m.Minute')}}</div>
    </div>
    <div class="row">
      <div class="row_label">{{$t('m.MeetingSponsor')}}</div>
      <div>{{meeting.create_user_name}}</div>
    </div>
    <div class="row">
      <div class="row_label">{{$t('m.MeetingBrief')}}</div>
      <div>{{meeting.meeting_content}}</div>
    </div>
    <div class="row">
      <div class="row_label">{{$t('m.MeetingParticipants')}}</div>
      <div>{{meeting.cf_party_name}}</div>
    </div>
    <div class="row">
      <div class="row_label">{{$t('m.MeetingTerminal')}}</div>
      <div style="width:73%">{{meeting.cf_terminal_name}}</div>
    </div>
    <div class="row">
      <div class="row_label">{{$t('m.MeetingHost')}}</div>
      <div class="row_content">{{meeting.cf_host_name}}</div>
    </div>
    <!-- 会议状态
      state:1  预约
            2  正在进行
            3  历史会议
     -->
    <div class="line" style="text-align:center;margin-top: 0.02rem;">
      <div @click="clearsure=true" class="button color bdc" v-if="check() && meeting.state==1">{{$t('m.CancelMeeting')}}</div>
      <div @click="changemeeting" class="button color bdc" v-if="check() && meeting.state==1">{{$t('m.ModifyMeeting')}}</div>
      <div
        @click="addterminalByQrCode"
        v-if="showAddTerminal==true"
        class="button color bdc"
        style="width: 0.9rem;"
      >{{$t('m.ScanterminalQRCodeJionMeeting')}}</div>
      <div @click="goback" class="button color bdc" style="width: 0.7rem;">{{$t('m.Return')}}</div>
    </div>
    <div class="pop" v-if="clearsure">
      <div class="templatepopexit">
        <!-- <div class="popclosex" @click="closeallpop"><Icon type="ios-close"></Icon></div> -->
        <div class="title-line">
          <img class="iconimg" :src="hookUrl" />
          <span class="title_sure">{{$t('m.CloseConfirm')}}</span>
        </div>
        <div class="templatepoptop">{{$t('m.ConfirmDeleteMeeting')}}</div>
        <div @click="clearsure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="delmeeing()" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
    <a
      :href="downHref"
      class="line bgc"
      style="display:block;color:#fff!important;text-align:center!important;text-decoration: none;margin-bottom: 10px;"
    >{{$t('m.ClickDownloadTerminalSoftware')}}</a>
    <div @click="toclose" class="pictoshow" v-if="istoshow">
      <img alt src="../../assets/images/public/toother.png" />
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
import Header from "../header/header";
import {
  delmeeting,
  selectConfDetail,
  wxLogin,
  systemmessage
} from "../../assets/js/url";

export default {
  name: "meetdetail",
  data() {
    return {
      hookUrl: require("@/assets/images/public/confirm.png"),
      meeting: Object,
      meetinguuid: null,
      showAddTerminal: false, //是否显示增加终端按钮
      downHref: "",
      clearsure: false,
      istoshow: false
    };
  },
  components: {
    Header
  },
  activated() {
    this.meetinguuid = this.$route.query.meetinguuid;
    this.showAddTerminal = this.$route.query.showAddTerminal;
    this.down();
    this.getmeetingdetail();
    // this.getsystemmessagee()
  },

  computed: {
    sameLinks(){
      if(this.meeting.callInfoMap){
        let arr = [].concat(this.meeting.callInfoMap.externalCallUrlList,this.meeting.callInfoMap.internalCallUrlList)
        arr = Array.from(new Set(arr))
        return this.meeting.callInfoMap.externalCallUrlList.length!=0 && arr.length == this.meeting.callInfoMap.internalCallUrlList.length;
      }else{
        return false
      }
    }
  },
  
  methods: {
    //--通过扫描二维码加终端
    addterminalByQrCode() {
      this.$router.push({
        path: "/wxLogin",
        query: {
		  gotoScan:"true",
		  key: window.sessionStorage.getItem("wx_key"),
          type: "addTerminal", 
          meetingId: this.meetinguuid //会议的数据库id
        }
      });
    },
    toshow() {
      if (this.weixintyped()) {
        this.istoshow = true;
        return false;
      }
    },
    toclose() {
      this.istoshow = false;
    },
    weixintyped() {
      const ua = window.navigator.userAgent.toLowerCase();
      //mozilla/5.0 (iphone; cpu iphone os 9_1 like mac os x) applewebkit/601.1.46 (khtml, like gecko)version/9.0 mobile/13b143 safari/601.1
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    //生成二维码的，前端自己生成，暂且不用了
    qrcode() {
      document.getElementById("qrcode").innerHTML = "";
      let url = this.$store.state.serverurl;
      let qrcode = new QRCode("qrcode", {
        // width: 100,
        // height: 100, // 高度
        text: url + "?meetinguuid=" + this.meetinguuid // 二维码内容
        // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f'
        // foreground: '#ff0'
      });
    },
    check() {
      if (
        window.sessionStorage.getItem("userStatus") == "1" ||
        window.sessionStorage.getItem("UUID") == this.meeting.createuser
      ) {
        return true;
      } else {
        return false;
      }
      const data = new Date();
      const preDate = new Date(this.meeting.meeting_date).getTime();
      return data.getTime() < preDate;
    },
    down() {
      this.downHref = window.sessionStorage.getItem("downUrl") || "";
    },
    delmeeing() {
      this.$loadingshow();
      this.$http
        .post(delmeeting, {
          id: this.meeting.id,
          type: 2
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.$toast(this.$t('m.GetBookMeetingListOK'));
              this.clearsure = false;
              this.$router.go(-1);
            } else {
              this.$toast(this.$t('m.CancelFail'));
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.NetworkException'));
          }
        );
    },
    goback() {
      this.$router.go(-1);
    },
    attendinit() {
      // 记录store归零，暂时不用
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfpartyname", "");
      this.$store.commit("setmeetingcfhost", "");
      this.$store.commit("setmeetingcfhostname", "");
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfparty", "");
      this.$store.commit("setmeetingcfterminal", "");
      this.$store.commit("setmeetingcfterminalname", "");
    },
    changemeeting() {
      this.attendinit();
      window.sessionStorage.setItem("meeting", JSON.stringify(this.meeting));
      this.$store.commit("setmeetingcfparty", this.meeting.cf_party);
      this.$store.commit("setmeetingcfterminal", this.meeting.cf_terminal);
      this.$store.commit("setmeetingcfhost", this.meeting.cf_host);
      //与会人员
      this.$store.commit("setmeetingcfpartyname", this.meeting.cf_party_name);
      this.$store.commit(
        "setmeetingcfterminalname",
        this.meeting.cf_terminal_name
      );
      this.$store.commit("setmeetingcfhostname", this.meeting.cf_host_name);
      this.$router.push({
        name: "changemeeting"
        // params: {
        //   meeting: this.meeting
        // }
      });
    },
    getmeetingdetail() {
      this.$loadingshow();
      this.$http
        .post(selectConfDetail, {
          id: this.meetinguuid
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.meeting = res.data.data;
            } else {
              this.meeting = {};
            }
          },
          err => {
            this.$toast(this.$t('m.GetListFail'));
            this.$loadingclose();
          }
        );
    }
  }
};
</script>
<style scoped>
.line {
  width: 100%;
  min-height: 0.44rem;
  line-height: 0.44rem;
}
.qrcodewarp {
  width: 2rem;
  height: 2rem;
  padding: 0.2rem;
  display: inline-block;
  /* background: #fff; */
}

#qrcode {
  width: 100%;
  height: 100%;
  display: inline-block;
}

.meetdetail {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0.15rem;
  font-size: 0.14rem;
  /* line-height: 0.41rem; */
}

.row {
  width: 100%;
  min-height: 0.44rem;
  line-height: 0.44rem;
  display: flex;
  border-bottom: 1px solid #d7d5d5;
  font-size: 0.14rem;
}
.row_label {
  width: 27%;
}
.row_content {
  width: 73%;
  word-wrap: break-word;
}

.left {
  float: left;
  width: 1.05rem;
  text-align: left;
}

.warp {
  height: 2.5rem;
  padding: 0.1rem 0;
  text-align: center;
}

.bigrow {
  border-bottom: 1px solid #d7d5d5;
}

.content {
  line-height: 0.28rem;
  width: 2.3rem;
  float: left;
}

.button {
  display: inline-block;
  width: 0.8rem;
  height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  border-radius: 3px;
  margin: 0 0.1rem;
}

a {
  text-decoration: underline;
}

.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  color: #3b3b3b;
}

.templatepopexit {
  width: 2.7rem;
  height: auto;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -0.6rem;
  margin-left: -1.35rem;
  box-sizing: border-box;
  padding: 0.2rem 0.1rem;
  text-align: center;
}
.templatepopexit .title-line {
  text-align: left;
}
.templatepopexit .iconimg {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.templatepopexit .title_sure {
  margin-left: 0.03rem;
  font-weight: bold;
}

.templatepoptop {
  height: 0.4rem;
  text-align: center;
  line-height: 0.4rem;
}

.templatepopmiddle {
  height: 0.5rem;
  line-height: 0.5rem;
  border-radius: 5px;
  background: #f6f7fa;
  text-align: center;
}

.templatepopmiddle input {
  width: 2rem;
  height: 0.4rem;
  border: none;
  outline: none;
  vertical-align: middle;
  background: transparent;
}

.templatepopbottom {
  margin-top: 0.1rem;
  border-top: 1px solid #eee;
  text-align: center;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.14rem;
}

.templatepopbottomexit {
  margin: 0.1rem 0.1rem 0;
  color: #fff;
  text-align: center;
  height: 0.3rem;
  width: 0.6rem;
  border-radius: 3px;
  display: inline-block;
  line-height: 0.3rem;
}

.pictoshow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10000000000;
}

.pictoshow img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/content/meetdetail.vue